import Config from '../config';
import { extractHyperlink } from './NavigationUtil';

export const hasFilePath = (eventTarget: { pathname: string }): boolean => {
  return eventTarget.pathname != null && /^.*\.[a-zA-Z0-9]*$/.test(eventTarget.pathname);
};

export const hasCurrentHost = (eventTarget: { host?: string; href?: string }): boolean => {
  if (eventTarget.host) {
    return isSameHost(eventTarget.host);
  }

  return isSameProtocolAndHost(eventTarget.href);
};

export const isSuperSelfService = (eventTarget: { host?: string; href?: string }) => {
  const regex = /\/(et|ru|en)\/self(?:\/|$)/;
  return regex.test(eventTarget.href);
};

const isSameHost = (host: string) => {
  return host === window.location.host || (['local', 'ui-test'].includes(Config.environment) && isDevHost(host));
};

const isDevHost = (hostname: string) => {
  return Config.devHostAliasNames && Config.devHostAliasNames.includes(hostname);
};

const isSameProtocolAndHost = (href: string) => {
  return (
    (href || '').startsWith(`${window.location.protocol}//${window.location.host}`) ||
    (['local', 'ui-test'].includes(Config.environment) && isDevProtocolAndHost(href))
  );
};

const isDevProtocolAndHost = (href: string) => {
  const link = extractHyperlink(href);
  return link.protocol === 'https:' && isDevHost(link.host);
};

export const toPathname = (path: string[]): string => {
  return `/${path.join('/')}`;
};

export const toPath = (url: string): string[] => {
  const pathname = ensurePathname(url);
  return pathname.split('/').filter((path) => path);
};

const ensurePathname = (url: string): string => {
  if (!url) {
    return url;
  }
  return url.startsWith('/') ? url : extractHyperlink(url).pathname;
};

export const removeTrailingSlash = (value: string): string => {
  return value !== '/' ? value.replace(/\/$/, '') : value;
};

export const getAppFromUrl = (url: string): App => {
  if (!url) {
    return null;
  }
  const appRegex = /(?:https?:\/\/)?(?:[a-zA-Z0-9-]+\.)*(diil|super)\.ee/;
  const matches = url.match(appRegex);
  return matches?.length ? (matches.pop() as App) : null;
};
